import { render, staticRenderFns } from "./HMPopoverMenuItem.vue?vue&type=template&id=6000f35e&scoped=true&"
import script from "./HMPopoverMenuItem.vue?vue&type=script&lang=ts&"
export * from "./HMPopoverMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./HMPopoverMenuItem.vue?vue&type=style&index=0&id=6000f35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000f35e",
  null
  
)

export default component.exports